<template>
    <div>
        <el-upload
        :multiple="false"
        :data="UploadData"
        :file-list="fileList"
        :on-success="successUploadForm"
        :on-preview="previewUploadForm"
        :on-remove="romoveUploadForm"
        :before-upload="beforeUploadForm"
        :on-error="errorUploadForm"
        :action="upLoadImg"
        :limit="limit"
        :on-exceed="handleExceed"
        :disabled="disabled"
        :drag="drag"
        :tip="tip"
        :list-type="listType">
            <div v-if="listType==='picture-card'">
                <i class="el-icon-plus"></i>
                <div v-if="drag" class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </div>
            <div v-else><el-button size="small" type="primary">上传文件</el-button></div>
            <div class="el-upload__tip" slot="tip">{{tip}}</div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
    import { upLoadImg } from '../../../config';
    export default {
        props: {
           UploadData: {
               type: Object,
               default: () => {}
           },
           value: {
               type: String,
               default: ''
           },
           limit: {
               type: Number,
               default: 1
           },
           disabled: {
               type: Boolean,
               default: false
           },
           formMaxSize: {
               type: Number,
               default: 50
           },
           upLoadImg: {
               type: String,
               default: upLoadImg
           },
           drag: {
               type: Boolean,
               default: false
           },
           tip: {
                type: String,
                default: '只能上传jpg/jpeg/png文件，图片比例为：1:1'
           },
           type: {
                type:Number,
                default: 1, //1图片2视频
           },
           listType: {
                type: String,
                default: 'picture-card'
           }
        },
        data() {
            return {
                // upLoadImg: '',
                fileList: [],
                imgs: '',
                one: 1,
                dialogImageUrl: '',
                dialogVisible: false
            }
        },
        created() {
        },
        watch: {
            value: {
                handler: function(val) {
                    if(val){
                        this.imgs = val
                        this.fileList = [{url:val}]
                    }
				},
				immediate: true
            },
        },
        methods: {
            /** 上传图片之前 */
            beforeUploadForm(file) {
                // 验证文件大小
                if (file.size / 1024 / 1024 > this.formMaxSize) {
                    this.$message({
                        message: `上传文件大小不能超过${formMaxSize}M!`,
                        type: 'warning',
                        customClass: 'adminMsg'
                    });
                    return false
                }
                // 中文乱码处理
                if (file.raw) {
                    let reader = new FileReader() // 读取文件内容
                    reader.readAsText(file.raw, 'gb2312') // 防止中文乱码问题，不加reader.onload方法都不会触发
                    reader.onload = function (e) {
                    this.contentHtml = e.target.result // txt文本内容，接下来就可以对其进行校验处理了
                    }
                }
                // 验证文件类型
                var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
                if(this.type===1){
                    let extension = testmsg === 'jpg' || testmsg === 'png' || testmsg === 'jpeg'
                    if (!extension) {
                        this.$message({
                            message: '上传文件只能是jpg/jpeg/png格式!',
                            type: 'warning',
                            customClass: 'adminMsg'
                        })
                        return false
                    }
                }else if(this.type===2){
                    let extension = testmsg === 'mp4'
                    if (!extension) {
                        this.$message({
                            message: '上传文件只能是mp4格式!',
                            type: 'warning',
                            customClass: 'adminMsg'
                        })
                        return false
                    }
                }
                
            },
            /** 图片上传成功之后 */
            successUploadForm(res) {
                if(res.code === 200){
                    this.$message({
                        message: res.msg,
                        type: 'success',
                        customClass: 'adminMsg'
                    });
                    this.imgs = res.data.fileUrl
                    this.$emit('input', this.imgs)
                }
            },
            // 预览图片
            previewUploadForm(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleExceed(files, fileList) {
                this.$message({
                    message: `当前限制选择 ${this.limit} 个文件，请先删除后再上传`,
                    type: 'warning',
                    customClass: 'adminMsg'
                });
                // this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            /** 删除图片之前 */
            romoveUploadForm(file) {
                console.log(file)
                if (file.status === 'success') {
                    this.imgs = ''
                    this.fileList = []
                    this.$emit('input', this.imgs)
                }
            },
            /** 文件上传失败 */
            errorUploadForm() {
                this.$message({
                    message: '上传失败',
                    type: 'error',
                    customClass: 'adminMsg'
                });
            }
        },
    }
</script>

<style>
</style>